import { FC, ReactNode } from 'react';
import { VoidFn } from 'types/baseTypes';
import OutsideClickHandler from 'react-outside-click-handler';

interface OutsideClickHandlerProps {
  onOutsideClick: VoidFn;
  children: ReactNode;
  disabled?: boolean;
}

const OutsideClickHandle: FC<OutsideClickHandlerProps> = ({ onOutsideClick, children, disabled = false }) => {
  return (
    <OutsideClickHandler onOutsideClick={onOutsideClick} disabled={disabled}>
      {children}
    </OutsideClickHandler>
  );
};

export default OutsideClickHandle;
